// ***************************************
// tgfComponents.ComponentLobbyList
//
// This is an empty template for a new component
//
// Copyright 2015 Tingly Games B.V.
// Last Changed: 2592015
// ***************************************
import { angrybirds_regular } from "../../code/AssetDefinitions/FontDefinitions";
import { tgfGraphics } from "../tgfGraphics";
import { tgfSettings } from "../tgfSettings";
import { ComponentBase } from "./ComponentBase";
import { ComponentLabel } from "./ComponentLabel";
import { ComponentPicture } from "./ComponentPicture";
import { tgfComponents } from "./tgfComponents";
// TODO: Everywhere replace Template and template by the appropriate name
// Directives for jslint
/*global tbEase, tbVectorFont, tbGraphics, tbImage, tbSurface, tbGame */
/*global tgfComponents, tgfScale, tgfEffects, tgfDictionary, tgfAudio, tgfSettings */
tgfSettings.componentDefaults.componentLobbyList = {
    _hasTop: true,
    _hasLast: true,
    imageTop: null,
    imageItem: null,
    imageItemLast: null,
    sliceMargin: [],
    isTopNineSliced: false,
    isItemNineSliced: false,
    nineSliceWidth: 800,
    fontTopSize: 28,
    fontTopFillColor: '#000000',
    fontTopAlign: 'center',
    fontTopOffset: {
        x: 0,
        y: 4
    },
    font: angrybirds_regular,
    headingText: 'DEFAULT',
    components: [] // Components to add as children
};
// The constructor for the component
/**
* @constructor
* @base ComponentBase
*/
tgfComponents.ComponentLobbyList = function (properties) {
    "use strict";
    this.name = "ComponentLobbyList"; // The name of the component
    // Initialize properties
    this.initialize(tgfSettings.componentDefaults.componentLobbyList);
    if (tgfSettings.lobbyScreenDialogProperties) {
        this.setProperties(tgfSettings.lobbyScreenDialogProperties);
    }
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    // setup data here
    // this._hasTop = true;
    // this._hasLast = true;
    this.listItems = [];
};
export var ComponentLobbyList = tgfComponents.ComponentLobbyList;
// Inherit the base component
tgfComponents.inherit(tgfComponents.ComponentLobbyList, ComponentBase);
// ***************************************
// Size information (e.g. for design support)
// TODO: Override these when not default
// ***************************************
// Returns the width of the component. Must be overriden if it is not the width property
tgfComponents.ComponentLobbyList.prototype.getWidth = function () {
    "use strict";
    return this.width === undefined ? 0 : this.width;
};
// Returns the height of the component. Must be overriden if it is not the height property
tgfComponents.ComponentLobbyList.prototype.getHeight = function () {
    "use strict";
    if (this._hasTop)
        this.height = this.imageTop.height;
    var len = this.items.length;
    for (var i = 0; i < len; i++) {
        if (i == (len - 1) && this.imageItemLast) {
            this.height += this.imageItem.height;
        }
        else {
            this.height += this.imageItem.height;
        }
    }
    if (this.imageItemLast)
        this.height += this.imageItemLast.height;
    return this.height === undefined ? 0 : this.height;
};
// Returns the left position of the component (in its own coordinate system). Must be overriden if it is not centered
tgfComponents.ComponentLobbyList.prototype.getLeft = function () {
    "use strict";
    return -this.getWidth() / 2;
};
// Returns the top position of the component (in its own coordinate system). Must be overriden if it is not centered
tgfComponents.ComponentLobbyList.prototype.getTop = function () {
    "use strict";
    return -this.getHeight() / 2;
};
// ***************************************
// Specific methods for this component
// ***************************************
// ***************************************
// Internal methods
// ***************************************
// ***************************************
// Preparing, showing and activating
//       These can be removed if no processing is required
// ***************************************
// Processing required when preparing the component for use
tgfComponents.ComponentLobbyList.prototype.doPrepare = function () {
    "use strict";
    var posY = this.y || 0;
    var items = this.items || [];
    var itemHeight = this.imageItem.height;
    // passed listitem defined?
    if (!this.componentItemClass) {
        throw new Error('ComponentLobbyList.componentItemClass not defined');
        return;
    }
    if (this._hasTop) {
        if (this.isTopNineSliced) {
            this._listTop = new ComponentPicture({
                createFromSlices: true,
                sliceMarginsArray: this.sliceMargin,
                width: this.nineSliceWidth,
                x: ((tgfGraphics.areaWidth - this.nineSliceWidth) / 2) + this.x,
                y: 0,
                image: this.imageTop
            });
        }
        else {
            this._listTop = new ComponentPicture({
                x: ((tgfGraphics.areaWidth - this.imageTop.width) / 2) + this.x, y: 0,
                image: this.imageTop
            });
        }
        this.components.push(this._listTop);
        // todo > clean up!
        this.fontTop = this.font.clone();
        this.fontTop.fontSize = this.fontTopSize; //28;
        this.fontTop.fillColor = this.fontTopFillColor;
        this.fontTop.align = this.fontTopAlign;
        var textProps = {
            text: this.headingText,
            font: this.fontTop,
            x: (tgfGraphics.areaWidth / 2 + this.fontTopOffset.x) + this.x,
            y: this.fontTopOffset.y,
            height: this.imageTop.height,
            //align: 'center',
            fitToBox: false
        };
        this._textTop = new ComponentLabel(textProps);
        this.components.push(this._textTop);
        this.listItems.push(this._listTop);
    }
    var len = this.items.length;
    var item;
    var posY = 0;
    if (this._hasTop) {
        posY = this._listTop.y + this._listTop.getHeight();
        // console.log(this._listTop.getHeight());
    }
    // create 'empty item'
    if (this.items.length == 0) {
    }
    // create list normally
    else {
        for (var i = 0; i < len; i++) {
            // add normal entry
            item = new this.componentItemClass({ type: this.type, x: (tgfGraphics.areaWidth / 2) + this.x, y: posY, image: this.imageItem, data: this.items[i], isItemNineSliced: this.isItemNineSliced, nineSliceWidth: this.nineSliceWidth });
            this.components.push(item);
            this.listItems.push(item);
            posY += this.imageItem.height;
        }
    }
    if (this.imageItemLast) {
        this._listBottom = new ComponentPicture({ x: ((tgfGraphics.areaWidth - this.imageTop.width) / 2) + this.x, y: posY, image: this.imageItemLast });
        this.components.push(this._listBottom);
        this.listItems.push(this._listBottom);
    }
    // Add the child components
    if (this.components) {
        for (i = 0; i < this.components.length; i += 1) {
            this.addComponent(this.components[i]);
        }
    }
};
tgfComponents.ComponentLobbyList.prototype.setItems = function (items) {
    this.items = items;
    var len = this.items.length;
    var posY = this.y;
    if (this._hasTop) {
        posY = this._listTop.y + this._listTop.getHeight() / 2;
    }
    var item;
    for (var i = 0; i < len; i++) {
        // add normal entry
        item = new this.componentItemClass({ type: this.type, x: tgfGraphics.areaWidth / 2, y: posY + this.imageItem.height / 2, image: this.imageItem, data: this.items[i] });
        this.components.push(item);
        this.listItems.push(item);
        posY += this.imageItem.height;
    }
};
// Processing required when freeing the component from use
// tgfComponents.ComponentLobbyList.prototype.doFree = function() {
//     "use strict";
// };
// // Processing required when showing the component
// tgfComponents.ComponentLobbyList.prototype.doShow = function() {
//     "use strict";
// };
// // Processing required when hiding the component
// tgfComponents.ComponentLobbyList.prototype.doHide = function() {
//     "use strict";
// };
// // Processing required when activating the component
// tgfComponents.ComponentLobbyList.prototype.doActivate = function() {
//     "use strict";
// };
// // Processing required when deactivating the component
// tgfComponents.ComponentLobbyList.prototype.doDeactivate = function() {
//     "use strict";
// };
// // ***************************************
// // Methods called when events must be processed
// //       These can be removed when no processing is required
// //       When they return true, this event is no further processed
// //          by other components in the dialog
// //       Never call these methods yourself in other components,
// //          Use the inherited handle methods instead
// // ***************************************
// // Called at the beginning of each step
// tgfComponents.ComponentLobbyList.prototype.doBeginStep = function(timePassed) {
//     "use strict";
// };
// // Called when a touch is started or if a mouse button is pressed
// tgfComponents.ComponentLobbyList.prototype.doTouchDown = function(finger, x, y) {
//     "use strict";
// };
// // Called when a touch is ended or if a mouse button is released
// tgfComponents.ComponentLobbyList.prototype.doTouchUp = function(finger, x, y) {
//     "use strict";
// };
// // Called when the position of the mouse wheel is changed
// tgfComponents.ComponentLobbyList.prototype.doMouseWheel = function(delta, x, y) {
//     "use strict";
// };
// // Called immediately when a touch is started or if a mouse button is pressed
// tgfComponents.ComponentLobbyList.prototype.doImmediateTouchDown = function(finger, x, y) {
//     "use strict";
// };
// // Called immediately when a touch is ended or if a mouse button is released
// tgfComponents.ComponentLobbyList.prototype.doImmediateTouchUp = function(finger, x, y) {
//     "use strict";
// };
// // Called if the key with the given keyCode is pressed
// tgfComponents.ComponentLobbyList.prototype.doKeyDown = function(keyCode) {
//     "use strict";
// };
// // Called if the key with the given keyCode is released
// tgfComponents.ComponentLobbyList.prototype.doKeyUp = function(keyCode) {
//     "use strict";
// };
// // Called if a global alarm is reached
// tgfComponents.ComponentLobbyList.prototype.doAlarm = function(alarm) {
//     "use strict";
// };
// // Called if a special or userdefined event happens
// tgfComponents.ComponentLobbyList.prototype.doSpecial = function(id, args) {
//     "use strict";
// };
// // Called at the end of each step
// tgfComponents.ComponentLobbyList.prototype.doEndStep = function(timePassed) {
//     "use strict";
// };
// // Called just before drawing (also when not active)
// tgfComponents.ComponentLobbyList.prototype.doUpdateVisuals = function(timePassed) {
//     "use strict";
// };
// // Called when the component must be drawn (relative to position 0, 0)
// tgfComponents.ComponentLobbyList.prototype.doDraw = function() {
//     "use strict";
// };
// // Called after drawing the subcomponents
// tgfComponents.ComponentLobbyList.prototype.doEndDraw = function() {
//     "use strict";
// };
